"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ImageCard = _interopRequireDefault(require("../block/ImageCard"));
var _AdjustableTwoColumnGrid = _interopRequireDefault(require("../layout-wrappers/AdjustableTwoColumnGrid"));
var _Concat = _interopRequireDefault(require("../utils/Concat"));
var _SectionedContent = _interopRequireDefault(require("./SectionedContent"));
function CastInfoLayout(props) {
  const castMember = props !== null && props !== void 0 && props.castMember ? props.castMember : {
    ...props
  };
  (0, _react.useEffect)(() => {
    const tabContent = document.querySelector('tab-content');
    if (tabContent) window.scrollTo(0, tabContent.offsetTop - 24);
  }, []);
  return /*#__PURE__*/_react.default.createElement(_AdjustableTwoColumnGrid.default, null, /*#__PURE__*/_react.default.createElement(_ImageCard.default, {
    image: {
      url: castMember.image.url,
      aspectRatio: castMember.image.aspectRatio
    }
  }), /*#__PURE__*/_react.default.createElement(_SectionedContent.default, {
    sections: [{
      header: {
        type: 'primary',
        title: castMember.real_name
      },
      content: /*#__PURE__*/_react.default.createElement(_Concat.default, {
        list: [`<div>${castMember.name}</div>`, castMember.hometown && castMember.birthday ? `<strong>Hometown</strong> ${castMember.hometown} <span class="contact-info-pipe">|</span> <strong>Birthday</strong> ${castMember.birthday}` : '']
      })
    }, {
      header: {
        type: 'secondary',
        title: 'Biography'
      },
      content: castMember.biography
    }, {
      header: {
        type: 'secondary',
        title: 'Follow'
      },
      content: castMember !== null && castMember !== void 0 && castMember.facebookHandle || castMember !== null && castMember !== void 0 && castMember.twitterHandle || castMember.instagramHandle ? /*#__PURE__*/_react.default.createElement(_Concat.default, {
        list: [castMember.facebookHandle ? `<span class="cast__follow-platform">Facebook: <a class="cast__follow-link" href="https://facebook.com/${castMember.facebookHandle}" target="_blank" rel="noreferrer">${castMember.facebookHandle}</a></span> ` : null, castMember.twitterHandle ? `<span class="cast__follow-platform">Twitter: <a class="cast__follow-link" href="https://twitter.com/${castMember.twitterHandle}" target="_blank" rel="noreferrer">@${castMember.twitterHandle}</a></span>` : null, castMember.instagramHandle ? `<span class="cast__follow-platform">Instagram: <a class="cast__follow-link" href="https://instagram.com/${castMember.instagramHandle}" target="_blank" rel="noreferrer">@${castMember.instagramHandle}</a></span>` : null]
      }) : ''
    }]
  }));
}
var _default = exports.default = CastInfoLayout;